import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    MatCell, MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
    MatTable
} from "@angular/material/table";
import { MatAnchor, MatButton } from "@angular/material/button";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { RouterLink } from "@angular/router";
import { ClaimsAppCustomerComponent } from './claims-app-customer/claims-app-customer.component';
import { ClaimsAppDashboardComponent } from "./claims-app-dashboard/claims-app-dashboard.component";
import { ClaimsAppLandingComponent } from "./claims-app-landing/claims-app-landing.component";
import { ClaimsAppMechanicalBreakdownComponent } from './claims-app-mechanical-breakdown/claims-app-mechanical-breakdown.component';
import { ClaimsAppSubmissionComponent } from './claims-app-submission/claims-app-submission.component';
import { ClaimsAppToolbarComponent } from "./claims-app-toolbar/claims-app-toolbar.component";
import { AuthService } from "../auth/auth.service";
import { ClaimModule } from "../claims/claim.module";
import { UserService } from "./services/user.service";
import { UserManager } from "./services/user.manager";
import { UserCache } from "./services/user.cache";
import { UserOverviewComponent } from "./user-overview/user-overview.component";
import { SharedModule } from "../../shared/shared.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ReferenceCache } from '../reference/services/reference.cache';
import { ReferenceService } from '../reference/services/reference.service';
import { ClaimsAppProgressStepComponent } from './claims-app-progress-step/claims-app-progress-step.component';
import { ClaimsAppConcernCauseComponentListComponent } from './claims-app-concern-cause-component-list/claims-app-concern-cause-component-list.component';
import { ClaimsAppConcernCausePartComponent } from './claims-app-concern-cause-part/claims-app-concern-cause-part.component';
import { ClaimsAppCoverageComponentSelectionComponent } from './claims-app-coverage-component-selection/claims-app-coverage-component-selection.component';
import { EstimateTotalComponent } from './estimates/estimate-total/estimate-total.component';
import { CorrectionEstimateComponent } from './estimates/correction-estimate/correction-estimate.component';
import { CorrectionEstimateListComponent } from './estimates/correction-estimate-list/correction-estimate-list.component';
import { EstimateListComponent } from './estimates/estimate-list/estimate-list.component';
import { PartEstimateComponent } from './estimates/part-estimate/part-estimate.component';
import { LaborEstimateComponent } from './estimates/labor-estimate/labor-estimate.component';
import { MaterialEstimateComponent } from './estimates/material-estimate/material-estimate.component';

@NgModule({
    declarations: [
        ClaimsAppCustomerComponent,
        ClaimsAppConcernCausePartComponent,
        ClaimsAppConcernCauseComponentListComponent,
        ClaimsAppDashboardComponent,
        ClaimsAppLandingComponent,
        ClaimsAppMechanicalBreakdownComponent,
        ClaimsAppSubmissionComponent,
        ClaimsAppToolbarComponent,
        UserOverviewComponent,
        ClaimsAppProgressStepComponent,
        ClaimsAppCoverageComponentSelectionComponent,
        EstimateTotalComponent,
        EstimateListComponent,
        PartEstimateComponent,
        LaborEstimateComponent,
        MaterialEstimateComponent,
        CorrectionEstimateComponent,
        CorrectionEstimateListComponent,
    ],
    exports: [
        ClaimsAppSubmissionComponent,
        ClaimsAppToolbarComponent,
        EstimateListComponent
    ],
    imports: [
        CommonModule,
        ClaimModule,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatCell,
        MatHeaderCell,
        MatHeaderRow,
        MatRow,
        MatCellDef,
        MatHeaderRowDef,
        MatRowDef,
        MatAnchor,
        MatButton,
        MatCheckboxModule,
        MatListModule,        
        MatAutocompleteModule,
        ReactiveFormsModule,
        RouterLink,
        SharedModule,
        FontAwesomeModule,
        FormsModule,
        NgxMaskModule.forRoot(),
    ],
    providers: [
        AuthService,
        UserService,
        UserManager,
        { provide: 'USER_CACHE', useValue: UserCache },
        ReferenceCache,
        ReferenceService
    ]
})
export class ClaimsAppModule { }
